// extracted by mini-css-extract-plugin
module.exports = {"body":"SearchTableBody_body__2T4MB","cell":"SearchTableBody_cell__PWC0j"};